import { UserApiService } from 'src/app/user-api.service';
import { AutorizationService } from 'src/app/api/autorization.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';

import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  constructor(public router: Router, public snackBar: MatSnackBar, private activatedRoute: ActivatedRoute, private UserApiService: UserApiService,
    private authService: AutorizationService, private formBuilder: FormBuilder, public dialog: MatDialog) {
    localStorage.removeItem('token_clem_mobi');
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];
    });
  }

  formGroup: FormGroup;
  submitted = false;
  loading = false;
  token : string;

  hidePassword = true;
  hideConfirmPassword = true;

  private subscription: any;


  ngOnInit(): void {
    this.createForm();
  }


  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }




  createForm() {

    this.formGroup = this.formBuilder.group({
      password: ['', [Validators.required, this.checkPassword]],
      confirmPassword: ['', Validators.required]
    }, {
      validator: this.MustMatch('password', 'confirmPassword')
    });
  }





 checkPassword(control: FormControl) {
  const value = control.value || '';
  const strongPassword =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;

  return strongPassword.test(value) ? null : { requirements: true };
}


  getErrorPassword() {
    return this.formGroup.get('password').hasError('required') ? 'Mot de passe requis' :
      this.formGroup.get('password').hasError('requirements') ?
        'Le mot de passe doit comporter au moins 8 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial' : '';
  }


  getErrorConfirmPassword() {
    return this.formGroup.get('confirmPassword').hasError('required') ? 'Confirmation mot de passe requise' :
      this.formGroup.hasError('MustMatch') ?
        '' : 'Les mots de passe saisis ne sont pas identiques';
  }



  get f() { return this.formGroup.controls; }



  // login
  ResetPassword() {

    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    this.loading = true;

        this.UserApiService.resetPassword(this.formGroup.value.password, this.token ).subscribe(response => {
          // conslog(response)
          this.openSnackBarDone("Votre mot de passe a été réintisalisé")
          this.router.navigate(['/connexion']);
        }, error => {
          console.log(error)
          this.openSnackBarError(error)
        });
   

  }




  get passwordValue(): string {
  return this.formGroup.get('password')?.value || '';
}

hasMinLength(): boolean {
  return this.passwordValue.length >= 8;
}

hasUpperCase(): boolean {
  return /[A-Z]/.test(this.passwordValue);
}

hasLowerCase(): boolean {
  return /[a-z]/.test(this.passwordValue);
}

hasNumber(): boolean {
  return /[0-9]/.test(this.passwordValue);
}

hasSpecialChar(): boolean {
  return /[!@#$%^&*(),.?":{}|<>]/.test(this.passwordValue);
}





  openSnackBarDone(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['sucess-snackbar'],
      duration: 8000,
    });
  }


  openSnackBarError(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['error-snackbar'],
      duration: 6000,
    });
  }


}